import React from 'react';
import { AiCornerAgentWithContext, handleWidgetPosition, useOptionalAiWidgetConfig } from '@atlassian/csm-ai-search-trigger';
export var AiCornerAgentRenderer = function AiCornerAgentRenderer() {
  var aiWidgetConfig = useOptionalAiWidgetConfig();
  var supportWidgetConfig = aiWidgetConfig === null || aiWidgetConfig === void 0 ? void 0 : aiWidgetConfig.supportWidgetConfig;
  var isSSR = typeof window !== 'undefined' && (!!process.env.REACT_SSR || !!window.__SSR_RENDERED__);
  var showCornerAgent = Boolean(!isSSR && supportWidgetConfig && supportWidgetConfig.isEnabled && handleWidgetPosition(supportWidgetConfig.widgetPosition) === 'CORNER');
  return showCornerAgent ? /*#__PURE__*/React.createElement(AiCornerAgentWithContext, null) : null;
};